<template>
    <el-dialog class="m-cropperDialog m-dialog yd-operate-model new-model" title="剪裁图片" :visible.sync="show" width="800px" top="10vh" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" :before-close="close">
        <div class="cropper-content v-between">
            <div class="cropper" style="text-align:center">
                <div class="top-title">原图</div>   
                <vueCropper ref="cropper"
                    :img="option.img"
                    :outputSize="option.outputSize"
                    :outputType="option.outputType"
                    :info="true"
                    :full="option.full"
                    :canScale="option.canScale"
                    :canMove="option.canMove"
                    :canMoveBox="option.canMoveBox"
                    :original="option.original"
                    :autoCrop="option.autoCrop"
                    :fixed="option.fixed"
                    :fixedNumber="option.fixedNumber"
                    :centerBox="option.centerBox"
                    :infoTrue="option.infoTrue"
                    :fixedBox="option.fixedBox" @realTime="preview"></vueCropper>
            </div>
            <!-- 预览 -->
            <div class="m-preview">
                <div class="top-title">预览图</div>
                <div class="preview-img">
                    <div :style="previewStyle">  
                        <img :src="previews.url" :style="previews.img"> 
                    </div>
                </div>
            </div>   
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close" class="btnCancel">取 消</el-button>
            <!-- <el-button type="primary" class="btnNew" @click="rotateLeft">逆时针旋转</el-button>
            <el-button type="primary" class="btnNew" @click="rotateRight">顺时针旋转</el-button> -->
            <el-button type="primary"  class="btnNew" @click="submit" :loading="loading">确认上传</el-button>
        </div>
    </el-dialog>
</template>

<script>
/**
 * Created by zoumeiting on 2020/2/12.
 * 参考链接：https://github.com/xyxiao001/vue-cropper
 * 编辑器版本 v0.5.0
 * 
 */
import API from '@/fetch/api'
export default {
    props: {
        show: {//显示弹窗
            type: Boolean,
            default: false
        },
        fileInfo: {//图片的一些数据
            type: Object,
            default: ()=>{
                return {}
            }
        },
        fileUrl: {//图片链接
            default: ''
        },
        fixedNumber: {
            type: Array,
            default: ()=>{
                return [7, 5]
            }
        }
    },
    data(){
        return {
            loading: false,
            option: {
                img: this.fileUrl || '', // 裁剪图片的地址
                info: true, // 裁剪框的大小信息
                outputSize: 0.8, // 裁剪生成图片的质量
                outputType: 'jpeg', // 裁剪生成图片的格式
                canScale: false, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                fixedBox: false, // 固定截图框大小 不允许改变
                fixed: true, // 是否开启截图框宽高固定比例
                fixedNumber: [7, 5], // 截图框的宽高比例
                full: true, // 是否输出原图比例的截图
                canMoveBox: true, // 截图框能否拖动
                canMove: false, // 上传图片是否可以移动
                original: false, // 上传图片按照原始比例渲染
                centerBox: true, // 截图框是否被限制在图片里面
                infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
            },
            previews: {
                url: '',
                width: 0,
                height: 0,
            },
            previewStyle: {}
        }
    },
    watch: {
        fileUrl(){
            this.$set(this.option, 'img', this.fileUrl);
        },
        fixedNumber(){
            this.$set(this.option, 'fixedNumber', this.fixedNumber);
        },
        loading(){
            this.$refs.cropper.isDisabled = this.loading;
        }
    },
    methods: {
        rotateLeft(){
            this.$refs.cropper.rotateLeft();
        },
        rotateRight(){
            this.$refs.cropper.rotateRight();
        },
        close(data){
            if(typeof(data) == 'object' && data.code){
                this.$emit('close', data);
                return;
            }
            this.$emit('close');
        },
        // 预览
        preview(data){
            this.previews = data;
            this.previewStyle = {
                width: `${data.w}px`,
                height: `${data.h}px`
            };
        },
        // 点击裁剪，并上传
        submit() {
            let vm = this;
            vm.$refs.cropper.startCrop();
            vm.$refs.cropper.getCropBlob((data) => {
                vm.uploadproductimg(data);
            })
        },
        uploadproductimg (data) {
            let vm = this;
            let formData = new FormData();
            formData.append('uploadFile', data, vm.fileInfo.name);
            vm.loading = true;
            API.http({ fullUrl: '/image/upload', type: 'post',
                params: formData
            }).then(res => {
                vm.loading = false;
                if(res.code != 200) {
                    vm.$showAlert('文件上传失败，请重试', 'error');
                    return;
                }
                vm.close(res);
            }).catch(res => {
                vm.loading = false;
                vm.$showAlert('文件上传失败，请重试', 'error');
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.m-cropperDialog{
    .cropper-content {
        margin: 0 10px 10px;
        padding: 20px;
        background-color: #fff;
        border-radius: 4px;
        .top-title{
            margin-bottom: 12px;
            text-align: left;
        }
        .cropper {
            width: 400px;
            padding-right: 20px;
            border-right: 1px solid #E7EAEC;
            .vue-cropper{
                height: 400px;
                background-image: none;
            }
            /deep/ .cropper-crop-box{
                max-width: 100%;
            }
            /deep/ .cropper-modal{
                background-color: rgba(0, 0, 0, 0.1);
            }
        }
        .m-preview{
            width: 330px;
            padding-left: 20px;
            .preview-img{
                height: 400px;
                >div{
                    overflow: hidden;
                    margin: 0;
                    zoom: 0.82;
                }
            }
        }
    }
}
</style>